import { queryClient } from "src/App";
import { RQ_COMPANY_LIST_KEY } from "src/modules/company/hooks/useCompanyList";
import {
    RQ_USER_PROFILE_PERMISSIONS_KEY,
    UserProfilePermissionsResponse,
} from "src/modules/profile/hooks/Profile/useUserPermissions";
import { PATH_DASHBOARD } from "src/routes/paths";
import { WssSubscriptionEventTypes, WssSubscriptionPayload } from "../types/Wss";
import { RQ_COMPANY_DETAILS_KEY } from "../hooks/useCompanyDetails";

const navigateToDashboard = () => {
    if (window.location.pathname !== PATH_DASHBOARD) {
        window.history.pushState(null, "", PATH_DASHBOARD);
        window.dispatchEvent(new PopStateEvent("popstate"));
    }
};

export const resolveWssSubscriptionEvent = (wssPayload: WssSubscriptionPayload) => {
    switch (wssPayload.event) {
        case WssSubscriptionEventTypes.SUBSCRIPTION_ACTIVATED: {
            queryClient.refetchQueries({ queryKey: [RQ_COMPANY_DETAILS_KEY], exact: false });
            queryClient.refetchQueries({ queryKey: [RQ_COMPANY_LIST_KEY], exact: false });
            queryClient.refetchQueries({
                queryKey: [RQ_USER_PROFILE_PERMISSIONS_KEY],
                exact: false,
            });

            const currentPermissions = queryClient.getQueriesData<UserProfilePermissionsResponse>({
                queryKey: [RQ_USER_PROFILE_PERMISSIONS_KEY],
            });
            if (currentPermissions.length > 0) {
                currentPermissions.forEach((cp) => {
                    const queryKey = cp[0] as [string, string];
                    const cachedPermissions = cp[1];
                    if (queryKey[1] === wssPayload.companyId && cachedPermissions) {
                        queryClient.setQueryData(cp[0], {
                            ...cachedPermissions,
                            isCompanySubscriptionActive: true,
                        });
                    }
                });
            }

            navigateToDashboard();
            break;
        }
        default:
            break;
    }
};
